export default {
  welcome: 'Welcome',
  form: {
    firstname: 'First Name',
    middlename: 'Middle Name',
    lastname: 'Last Name',
    birthday: 'Date of Birth',
    age: 'Age',
    relationship: 'Relationship',
    birthcountry: 'BirthPlace Country',
    birthstate: 'BirthPlace State',
    civilState: 'Marital Status',
    gender: 'Gender',
    areacode: 'Area Code',
    homephone: 'Home Phone',
    ssn: 'Social Security Number',
    idexternal: 'Foreigners Identification',
    driverlicense: 'Driver License',
    changeadress: 'Si requieres completar tu dirección podemos ayudarte ingresando tu ubicación aquí.',
    send: 'Send',
    reset: 'Reset',
    required: 'This is a required field',
    addFamDisc: 'Al hacer clic en el botón Agregar, aceptas que la información aquí proveída es correcta y precisa. Hispano Club y los Terceros proveedores de servicios podrán negarse a prestar este servicio si cualquiera de las declaraciones son falsas, fraudulentas, negligentes, incompletas o engañosas de manera alguna.'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/index.js